import { useErrorContext } from '@qpr/client-library';
import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import { createViewModel } from '@qpr/map';
import { useQuery } from 'react-query';

type Attribute = {
  displayName: string;
  value: any;
};

export interface Hierarchy {
  id: string;
  name: string;
  typename: string;
  fullid: string;
  symbol: string;
  children: Hierarchy[];
  parentid?: string;
  parentPath?: string;
  roles: string[];
  attributes: Record<string, Attribute>;
}

interface HierarchyRequest {
  containerId: string;
  containerRelation: string;
  relation: string;
  connector: string;
  elementtypes: string[];
  recursive?: boolean;
  recursionCount?: number;
  criteria?: string;
  attributes: any;
  sortby?: string[];
  options?: string;
}

export const useHierarchy = ({ containerId, ...rest }: HierarchyRequest) => {
  const { setError } = useErrorContext();

  return useQuery<any, ErrorObject>(
    `hierarchy-${containerId}`,
    async () => {
      const vm = createViewModel({ containerId, ...rest });

      const { error, hierarchy } = await vm.getData();

      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      if (error) {
        setError(error);
        return null;
      }

      return hierarchy;
    },
    {
      enabled: !!containerId,
      staleTime: 60 * 1000
    }
  );
};

export default useHierarchy;
